import { createRoute, useEntityUrl } from 'framework/routing';
import { POSITION_PROFILES_PATH } from './constants';

export const usePositionProfilesRoute = () => createRoute({ listRoute: POSITION_PROFILES_PATH });

export const usePositionProfilesUrl = () => useEntityUrl({ baseLink: POSITION_PROFILES_PATH });
